// @flow
import React from "react";
import { connect } from "react-redux";
import { graphql } from "@apollo/client/react/hoc";
import {
  TracksRaces as TVGTrackRaces,
  mapStateToProps
} from "@tvg/tracks-builder/src/components/track-races";
import TracksGraphQuery from "@tvg/tracks-builder/src/components/track-races/graphql/queries/TracksGraph.graphql";
import TracksRDA from "@tvg/tracks-builder/src/components/track-races/graphql/queries/TracksRDA.graphql";
import RacesContainer from "@fdr/atomic-ui/_templates/RacesContainer";
import { isAccountCompliantSelector } from "@tvg/sh-utils/sessionUtils";
import { get, flowRight as compose } from "lodash";
import type { Props } from "@tvg/tracks-builder/src/components/track-races/types";
import ApolloOptions from "../../graphql/track-races-options.graph";

// $FlowFixMe - statics of TracksRaces [1] is not a polymorphic type.
export class TracksRaces extends TVGTrackRaces<Props> {
  render = () => (
    <RacesContainer
      idPrefix={this.props.idPrefix}
      isDisplayingRaces={this.props.isDisplayingRaces}
      raceList={this.props.raceList}
      trackCode={this.props.trackCode}
      trackName={this.props.trackName}
      raceIndexScroll={this.props.raceIndexScroll}
      isGreyhound={this.props.isGreyhoundsTrack}
      isLoading={this.props.isLoading}
      sendGTMScrollEvent={this.sendGTMScrollEvent}
      onRaceSelect={this.onRaceSelect}
      isTalentPicksContext={this.props.isTalentPicksContext}
      hasPromoBadge={this.props.hasPromoBadge}
      optedInPromos={this.props.optedInPromos}
      device={this.props.device}
      isFavorite={this.props.isFavorite}
      isOpen={this.props.isOpen}
      isLogged={this.props.isLogged}
      useNewProgramPageLayout={this.props.useNewProgramPageLayout}
      useIsPromoTagShownFlag={this.props.useIsPromoTagShownFlag}
    />
  );
}

export const skipGraphQuery = ({
  isLogged,
  isAccountCompliant,
  shouldUpdate
}: {
  isLogged: boolean,
  isAccountCompliant: boolean,
  shouldUpdate: boolean
}) => (isLogged && isAccountCompliant) || !shouldUpdate;

export const skipRDAQuery = ({
  isLogged,
  isAccountCompliant,
  shouldUpdate,
  accountId
}: {
  isLogged: boolean,
  isAccountCompliant: boolean,
  shouldUpdate: boolean,
  accountId: number
}) => !isLogged || !isAccountCompliant || !shouldUpdate || !accountId;

export default connect((store) => ({
  ...mapStateToProps(store),
  useIsPromoTagShownFlag: get(
    store,
    "capi.featureToggles.useIsPromoTagShownFlag",
    false
  ),
  isAccountCompliant: isAccountCompliantSelector(store),
  useNewProgramPageLayout: get(
    store,
    "capi.featureToggles.useNewProgramPageLayout",
    false
  )
}))(
  compose(
    graphql(TracksGraphQuery, {
      ...ApolloOptions,
      skip: skipGraphQuery
    }),
    graphql(TracksRDA, {
      ...ApolloOptions,
      skip: skipRDAQuery
    })
  )(TracksRaces)
);
